<script setup lang="ts">
import type { FilterWrapperProperties } from '@optionway/models';

const isOpen = ref(false);

const properties = withDefaults(defineProps<FilterWrapperProperties>(), {
  hasActiveFilters: false,
  disabled: false,
});
</script>

<template>
  <div>
    <UiPopover v-model:open="isOpen">
      <UiPopoverTrigger as-child>
        <UiCustomFilterTrigger
          :variant="properties.disabled ? 'disabled' : hasActiveFilters ? 'active' : 'default'"
          :is-opened="isOpen"
        >
          {{ triggerButtonLabel }}
        </UiCustomFilterTrigger>
      </UiPopoverTrigger>
      <UiPopoverContent
        class="flex max-h-80 w-85 flex-col gap-3 overflow-y-auto border-gray-400 p-3"
        align="start"
      >
        <slot />
      </UiPopoverContent>
    </UiPopover>
  </div>
</template>
